import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './lib/axios'
import print from './lib/print'
import config from '@/config'
import iView from 'iview'
import store from './store'
import Qs from 'qs'
import 'iview/dist/styles/iview.css'
import '@/components/scss/style.scss'
import Base from '@/components/common/base'

Vue.use(iView)
Vue.use(print)

Vue.use(Base)
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$axios = axios
Vue.prototype.$qs = Qs


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js